/* global window,document */
import inDOM from 'dom-helpers/util/inDOM';

export default inDOM && !!window.MSInputMethodContext && !!document.documentMode;
